import {RootState} from '../../store';
import {MeterAssignment} from './types';

export const selectionSelector = (state: RootState): Record<string, MeterAssignment> =>
    state['meter-assignments'].selection as Record<string, MeterAssignment>;
